import axios, { AxiosRequestConfig, AxiosResponse, Method, AxiosError } from "axios";
// import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Buffer } from "buffer";
import { ApiKeys, ApiService } from "../constants";
import { directTypes, redirectToAzureAD } from "./AzureAD_Util";
import Swal from 'sweetalert2';
import { IRefreshTokenReducer } from '../reducers/RefreshTokenReducer'
import moment from "moment";

const encodeBase64DivID = (): string | null => {
  try {
    const base64DivID = Buffer.from(ApiKeys.icdc_division_id).toString(
      "base64"
    );

    return base64DivID;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const authorizationTypes = {
  BASIC: "Basic",
  BEARER: "Bearer",
};

const getAuthenticatedHeader = (
  authorizationType: string,
  token: string | null
) => {
  let parseHeaders = {
    "Content-Type": "application/json",
    'Authorization': "",
    "Binusian-Id": "",
    "Email": ""
  };

  let binusianID = "";
  let email = "";

  const base64DivID = encodeBase64DivID();

  if (authorizationType === authorizationTypes.BASIC && token === null) {
    if (base64DivID !== null) {
      parseHeaders = {
        ...parseHeaders,
        Authorization: `${authorizationType} ${base64DivID}`,
      };
    }
  } else if (authorizationType === authorizationTypes.BEARER) {

    const jsonString = localStorage.getItem('persist:root');

    if (jsonString != null) {
      const object = JSON.parse(jsonString);

      if (JSON.parse(object.auth).userData) {
        binusianID = JSON.parse(object.auth).userData.binusianId;
        email = JSON.parse(object.auth).userData.email;
      }
    }

    parseHeaders = {
      ...parseHeaders,
      'Authorization': `${authorizationType} ${token}`,
      "Email": `${email}`,
      "Binusian-Id": `${binusianID}` // `BN001474140`
    };
  }

  return parseHeaders;
};

const getSignedRequestOptions = (
  method: Method,
  data: unknown,
  authorizationType: string,
  token: string | null
) => {
  let parseHeaders = getAuthenticatedHeader(authorizationType, token);

  let requestOptions: AxiosRequestConfig = {
    method,
    data,
    headers: parseHeaders,
  };

  return requestOptions;
};

const getErrorMessageDisplay = (errorMessages: any) => {
  let result = '';
  if (errorMessages && errorMessages.length > 0) {
    for (const i in errorMessages) {
      result += '<li style="text-align: left;">' + errorMessages[i] + '</li>';
    }
  }
  if (result != '') {
    result = '<ul>' + result + '</ul>';
  }
  return result;
}

const doFetch = async (url: string, requestOptions: AxiosRequestConfig) => {
  return axios(url, requestOptions)
    .then(result => {
      return result;
    })
    .catch(err => {
      const error = err as AxiosError
      let errorMessage = error.response?.data;


      if (!errorMessage) {
        // Swal.fire({
        //   text: 'Error',
        //   title: 'Network/Server error',
        //   icon: 'error'
        // });
        console.error(err);
      } else {
        if (typeof errorMessage === 'string') {
          Swal.fire({
            html: 'An error has occured, please try again later.',
            title: `${errorMessage}`,
            icon: 'warning'
          });
          return errorMessage;
        }

        if (errorMessage.resultCode == 400) {
          if (errorMessage.errorMessages) {
            Swal.fire({
              html: errorMessage.errorMessages && errorMessage.errorMessages.length > 1 ? getErrorMessageDisplay(errorMessage.errorMessages) : (errorMessage.allErrorMessage || errorMessage.errorMessage),
              title: '',
              icon: 'warning'
            });
            return errorMessage;
          }

          Swal.fire({
            html: 'An error has occured, please try again later.',
            title: `${errorMessage.errorMessage}`,
            icon: 'warning'
          });
          return errorMessage;
        }

        if (errorMessage.resultCode == 401) {
          if (errorMessage.errorMessages) {
            Swal.fire({
              html: errorMessage.errorMessages && errorMessage.errorMessages.length > 1 ? getErrorMessageDisplay(errorMessage.errorMessages) : (errorMessage.allErrorMessage || errorMessage.errorMessage),
              title: '',
              icon: 'warning'
            }).then((result) => {

              if (result.value) {
                window.location.replace("/logout")
              }

            });
            return errorMessage;
          }

          Swal.fire({
            title: '',
            html: `${errorMessage.errorMessage}`,
            icon: 'warning'
          }).then((result) => {

            if (result.value) {
              window.location.replace("/logout")
            }

          });
          return errorMessage;
        }

        if (errorMessage.resultCode == 500) {
          Swal.fire({
            html: 'An error has occured, please try again later.',
            title: `${errorMessage.errorMessage}`,
            icon: 'warning'
          });
        }

        if (errorMessage.ResultCode == 403) {
          // HttpService.getTokenAuth().then((result) => {
          //   location.reload();
          // })

          console.log('request_info', { url, requestOptions });

          Swal.fire({
            text: 'Please logout and login again.',
            title: `${errorMessage.ErrorMessage}`,
            icon: 'warning'
          }).then((result) => {

            if (result.value) {
              window.location.replace("/logout")
            }

          });
        }

        if (error.response.status == 400) {
          errorMessage.resultCode = 400;
        }

      }
      console.log('errorMessage', errorMessage)
      return errorMessage;
    });
};

export const asyncLocalStorage = {
  key: window.location.origin,
  setItem: async function (value: any) {
    await null;
    return localStorage.setItem(this.key, JSON.stringify(value));
  },
  getItem: async function () {
    await null;
    return localStorage.getItem(this.key);
  },
  removeItem: async function () {
    return localStorage.removeItem(this.key);
  },
  removePersist: async function () {
    return localStorage.removeItem('persist:root');
  }
};

export const HttpService = {
  getAuthorizationToken<T = any>(url: string, username: string, password: string): Promise<AxiosResponse<T>> {
    const requestOptions = getSignedRequestOptions(
      password ? "POST" : "GET",
      password ? { userName: username, password: password } : null,
      authorizationTypes.BASIC,
      null
    );

    const resultresp = doFetch(url, requestOptions).then(result => {
      if (result.resultCode == '401') {
        return result;
      } else {
        asyncLocalStorage.setItem(result.data.tokenData);

        try {
          let _expiredToken = moment().add((result.data.tokenData.duration * 60) - 10, 'seconds'); // minuse 10 second for delay get request token
          localStorage.setItem("expiredToken", _expiredToken.format("YYYY-MM-DD HH:mm:ss"));
        } catch (error) { }

        return HttpService.post(ApiService.icdc.auth.userAuth, { userName: username }).then(resp => {
          return resp;
        });
      }

    });

    return resultresp;
  },
  getTokenAuth<T = any>(): Promise<AxiosResponse<T>> {
    const requestOptions = getSignedRequestOptions(
      "GET",
      null,
      authorizationTypes.BASIC,
      null
    );
    let _expiredToken = moment().add(300, 'seconds'); 
    localStorage.setItem("expiredToken", _expiredToken.format("YYYY-MM-DD HH:mm:ss"));
    const resultresp = doFetch(ApiService.icdc.auth.getToken, requestOptions).then(result => {
      if (result.resultCode == '401') {
        return result;
      } else {
        asyncLocalStorage.setItem(result.data.tokenData);
        let _expiredToken = moment().add((result.data.tokenData.duration * 60) - 10, 'seconds'); // minuse 10 second for delay get request token
        localStorage.setItem("expiredToken", _expiredToken.format("YYYY-MM-DD HH:mm:ss"));
        return result;
      }

    });

    return resultresp;
  },
  async get<T = any>(url: string): Promise<AxiosResponse<T>> {
    let token = "";

    //for hanlde browser inactive to cheking token expired
    await checkToken();

    await asyncLocalStorage.getItem().then(resp => {
      if (resp != null) {
        token = JSON.parse(resp).token;
      }
    })

    const requestOptions = getSignedRequestOptions(
      "GET",
      null,
      authorizationTypes.BEARER,
      token
    );
    return doFetch(url, requestOptions);
  },
  async post<T = any>(url: string, data: unknown): Promise<AxiosResponse<T>> {
    let token = '';

    //for hanlde browser inactive to cheking token expired
    await checkToken();

    await asyncLocalStorage.getItem().then(resp => {
      if (resp != null) {
        token = JSON.parse(resp).token;
      }
    })

    const requestOptions = getSignedRequestOptions(
      "POST",
      data,
      authorizationTypes.BEARER,
      token
    );
    return doFetch(url, requestOptions);
  },

  async getUnSave<T = any>(url: string): Promise<AxiosResponse<T>> {
    let requestOptions: AxiosRequestConfig = { method: "GET", data: null };
    return doFetch(url, requestOptions);
  },
  async postForm<T = any>(url: string, data: any, headers: any): Promise<AxiosResponse<T>> {
    if (!headers || headers.length <= 0) {
      headers = {};
    }
    const body = new URLSearchParams();
    if (data) {
      const propertyNames = Object.keys(data);
      for (const ix in propertyNames) {
        body.append(propertyNames[ix], data[propertyNames[ix]]);
      }
    }

    let requestOptions: AxiosRequestConfig = {
      method: "POST",
      data: body,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        ...headers
      }
    };

    return doFetch(url, requestOptions);
  },

  goToBeelajar(email: string, targetUrl: string) {
    const requetsPostRequestLogin = (email, callback) => {
      HttpService.postForm(ApiService.beelajar.postRequestLogin, {
        'wstoken': ApiKeys.beelajarToken2,
        'wsfunction': 'auth_userkey_request_login_url',
        'moodlewsrestformat': 'json',
        'user[email]': email,
      }, null)
        .then(resp => {
          if (resp.status === 200) {
            callback(resp.data);
          } else {
            console.error(resp)
          }
        });
    };

    requetsPostRequestLogin(email, (data) => {
      // console.log('data', data);
      if (!data.loginurl || data.loginurl == '') {
        alert('User Unauthorized');
        return;
      }
      window.open(data.loginurl, 'beelajarPage');
      setTimeout(() => {
        requetsPostRequestLogin(email, (data) => {
          window.open(data.loginurl + '&wantsurl=' + targetUrl, 'beelajarPage');
        });
      }, 500);
    });
  },

  onClickToDoBeelajar(todo: any) {
    const requetsPostRequestLogin = (email, callback) => {
      HttpService.postForm(ApiService.beelajar.postRequestLogin, {
        'wstoken': ApiKeys.beelajarToken2,
        'wsfunction': 'auth_userkey_request_login_url',
        'moodlewsrestformat': 'json',
        'user[email]': email,
      }, null)
        .then(resp => {
          if (resp.status === 200) {
            callback(resp.data);
          } else {
            console.error(resp)
          }
        });
    };

    HttpService.post(ApiService.icdc.module.notification.setToDoNotificationReadStatus, todo)
      .then(resp => {
        requetsPostRequestLogin(resp.data.data.email, (data) => {
          if (!data.loginurl || data.loginurl == '') {
            alert('User Unauthorized');
            return;
          }
          window.open(data.loginurl, 'beelajarPage');
          setTimeout(() => {
            requetsPostRequestLogin(resp.data.data.email, (data) => {
              window.open(data.loginurl + '&wantsurl=' + resp.data.data.url, 'beelajarPage');
            });
          }, 500);
        });
      })
      .catch((err) => {

      });
  },

  downloadFromBeelajar(email: string, targetUrl: string) {
    const requetsPostRequestLogin = (email, callback) => {
      HttpService.postForm(ApiService.beelajar.postRequestLogin, {
        'wstoken': ApiKeys.beelajarToken2,
        'wsfunction': 'auth_userkey_request_login_url',
        'moodlewsrestformat': 'json',
        'user[email]': email,
      }, null)
        .then(resp => {
          if (resp.status === 200) {
            callback(resp.data);
          } else {
            console.error(resp)
          }
        });
    };

    requetsPostRequestLogin(email, (data) => {
      setTimeout(() => {
        requetsPostRequestLogin(email, (data) => {
          window.open(data.loginurl + '&wantsurl=' + targetUrl, 'beelajarPage');
        });
      }, 500);
    });
  },
  async getSharepointCdn<T = any>(url: string): Promise<AxiosResponse<T>> {
    let requestOptions: AxiosRequestConfig = { method: "GET" };
    // let requestOptions: AxiosRequestConfig = { method: "GET", headers: { "Referrer-Policy": "unsafe-url", "Referer": "binusianorg.sharepoint.com"}};
    var savedPath = window.location.pathname;
    var savedSearch = window.location.search;
    window.history.replaceState(null, '', 'binusianorg.sharepoint.com');
    var res = doFetch(url, requestOptions);
    window.history.replaceState(null, '', savedPath + savedSearch);
    return res;
    // return doFetch(url, requestOptions);
  },

  goToBclnDFrontEnd(accessToken) {
    // window.open(ApiService.bclndFrontEnd.doLogin + '?access_token=' + accessToken, 'BclnDFrontEnd');
    const mapForm = document.createElement("form");
    mapForm.target = "_blank";
    mapForm.method = "POST";
    mapForm.action = ApiService.bclndFrontEnd.doLogin;

    // Create an input
    const mapInput = document.createElement("input");
    mapInput.type = "text";
    mapInput.name = "access_token";
    mapInput.value = accessToken;

    mapForm.appendChild(mapInput);
    document.body.appendChild(mapForm);
    mapForm.submit();
  },

  goToBclnDOldBackEnd(accessToken) {
    window.open(ApiService.bclndOldBackEnd.doLogin + '?FLAG=1&Token=' + accessToken, 'BclnDOldEnd');
  },

  goToBclnDNewBackEnd(accessToken) {
    const mapForm = document.createElement("form");
    mapForm.target = "_blank";
    mapForm.method = "POST";
    mapForm.action = ApiService.bclndNewBackEnd.doLogin;

    // Create an input
    const mapInput = document.createElement("input");
    mapInput.type = "text";
    mapInput.name = "access_token";
    mapInput.value = accessToken;

    mapForm.appendChild(mapInput);
    document.body.appendChild(mapForm);
    mapForm.submit();
  },
  goToFma(userName, accessToken) {
    window.open(ApiService.fma.doLogin + '&username=' + userName, 'Fma');
  },
};

const events = [
  "load",
  // "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
  "touchstart",
  "touchstart",
];

export const refreshTokenTimerOld = async () => {
  let duration = 0;
  let logoutDuration = 3600 * 3;

  await asyncLocalStorage.getItem().then(resp => {
    if (resp != null) {
      duration = JSON.parse(resp).duration * 60;
    }
  })

  let timeleft = localStorage.getItem("timer") ? parseInt(localStorage.getItem("timer")) : duration;
  let countdownTimer = setInterval(() => {
    timeleft--;
    console.log("timeleft", timeleft);

    if (timeleft <= 0) {
      timeleft = duration;
      HttpService.getTokenAuth()
    }

    localStorage.setItem("timer", timeleft.toString())

  }, 1000)

  let logoutTimer = setInterval(() => {
    logoutDuration--;
    console.log("logoutDuration", logoutDuration);
    if (logoutDuration <= 0) {
      window.location.replace("/logout")
    }

    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        logoutDuration = 3600 * 3;
      });
    });

    // console.log('logoutDuration', logoutDuration)

  }, 1000)
}

const checkToken = async () => {
  if (JSON.parse(localStorage.getItem('persist:root'))) {
    if (JSON.parse(JSON.parse(localStorage.getItem('persist:root')).auth)) {
      var userData = JSON.parse(JSON.parse(localStorage.getItem('persist:root')).auth).userData;
      // cek user logged in
      if (userData) {
        let _now = moment();
        let _expiredToken = (localStorage.getItem("expiredToken") ? moment(localStorage.getItem("expiredToken"), "YYYY-MM-DD HH:mm:ss") : _now).add(-5, 'seconds');
        await _validateToken(_now, _expiredToken);
      }
    }
  }
}

const _validateToken = async (currentDate, _expiredToken, callback = undefined) => {
  //add delay agar tidak cek token setiap detik incase ada token error
  if (_expiredToken) {
    if (_expiredToken.diff(currentDate, 'seconds') <= 60) {
      //localStorage.setItem("expiredToken", moment().add(85, 'seconds').format("YYYY-MM-DD HH:mm:ss"));
      console.log('token expired');
      HttpService.getTokenAuth();
      if (typeof (callback) === "function") {
        await callback();
      }
    }
  }
}

export const refreshTokenTimer = async (refreshAuthToken: any, runningInterval: any, stopInterval: any) => {
  const autoLogoutDuration = 3600 * 3;
  let _expiredToken = localStorage.getItem("expiredToken") ? moment(localStorage.getItem("expiredToken")) : null;

  let _expiredLogout = moment().add(autoLogoutDuration, 'seconds');

  const autoLogout = (currentDate) => {
    if (_expiredLogout.diff(currentDate, 'seconds') <= 0) {
      stopInterval();
      window.location.replace("/logout")
    }
  }

  Object.values(events).forEach((item) => {
    window.addEventListener(item, async () => {
      const _currentDate = moment();
      if (_expiredLogout.diff(_currentDate, 'seconds') >= 0) {
        _expiredLogout = _currentDate.add(autoLogoutDuration, 'seconds');
        runningInterval(_expiredToken, _expiredLogout);
      }
    });
  });

  runningInterval(_expiredToken, _expiredLogout);

  setInterval(async () => {
    const currentDate = moment();
    autoLogout(currentDate);
    _expiredToken = localStorage.getItem("expiredToken") ? moment(localStorage.getItem("expiredToken")) : null;
    await _validateToken(currentDate, _expiredToken, async () => {
      _expiredToken = localStorage.getItem("expiredToken") ? moment(localStorage.getItem("expiredToken")) : null;
      refreshAuthToken(_expiredToken, _expiredLogout);
    });
  }, 1000);
}

export const base64FileHeaderMapper = (fileBase64: any) => {

  let fileHeader = new Map();

  //get the first 3 char of base64
  fileHeader.set("/9j", "jpg")
  fileHeader.set("iVB", "png")
  fileHeader.set("Qk0", "bmp")
  fileHeader.set("SUk", "tiff")
  fileHeader.set("JVB", "pdf")
  fileHeader.set("UEs", "ofd")

  let res = ""

  fileHeader.forEach((v, k) => {
    if (k == fileBase64.substr(0, 3)) {
      res = v
    }
  })

  if (res == "") {
    res = "unknown file"
  }

  return 'data:image/' + res + ';base64,' + fileBase64
}

export const downloadBase64 = (url: string) => {
  return HttpService.post(
    ApiService.icdc.module.file.downloadBase64,
    { Url: url }
  )
    .then(resp => {
      return resp
    })
}

export const getSharepointCdnFile = (url: string) => {
  // return HttpService.getSharepointCdn(
  //   url
  // )
  // .then(resp => {
  //   return resp
  // })
  return ApiService.icdc.module.file.getSpCdnFile + "?uri=" + url;
}

export const getSharepointCdnFileMedia = (url: string) => {
  return ApiService.icdc.module.file.getSpCdnFileMedia + "?uri=" + url;
}

export const downloadFile = (filepath, filename) => {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", getSharepointCdnFile(encodeURIComponent(filepath)), true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement('a');
    tag.href = imageUrl;
    tag.download = filename;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  }

  xhr.send();
}

export const uploadImage = (fileName: any, fileData: any, fileCategory: any) => {
  return HttpService.post(
    ApiService.icdc.module.file.uploadImage,
    {
      FileName: fileName,
      FileData: fileData.replace(/^data:image\/[a-z]+;base64,/, ""),
      FileCategory: fileCategory
    }
  )
    .then(resp => {
      return resp
    })
}

export const uploadImageTinymce = (blobInfo: any, progress: any): Promise<string> => {
  return new Promise(function (resolve, reject) {
    var xhr, formData;

    xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open('POST', ApiService.icdc.module.file.uploadFileTinymce);

    xhr.upload.onprogress = function (e) {
      progress(e.loaded / e.total * 100);
    };

    xhr.onload = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var _location = JSON.parse(this.responseText).location;
          resolve(getSharepointCdnFile(_location));
        }
        else {
          console.error(xhr.statusText);
          reject(xhr.statusText);
        }
      } else {
        reject(xhr.statusText);
      }
    };

    xhr.onerror = function () {
      // failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
      reject(xhr.statusText);
    };

    formData = new FormData();
    formData.append('fileCategory', "Content");
    formData.append('files', blobInfo.blob(), blobInfo.filename());

    xhr.send(formData);
  });
}

export const validImage = (img) => {
  if (img.name.toLowerCase().match(/\.(jpg|jpeg|png|gif|tif|tiff)$/)) {
    return true;
  } else {
    Swal.fire({
      text: `Image not valid, please using image format jpg, jpeg, png, gif, tif, or tiff`,
      title: `Image Validation`,
      icon: 'warning'
    });
    return false;
  }
}

export const uploadFile = (file: any) => {
  return HttpService.post(
    ApiService.icdc.module.file.uploadFile,
    file
  )
    .then(resp => {
      return resp
    })
}

export const SupportingFileTypes = {
  'image': '.gif,.jpg,.jpeg,.png,.tif,.tiff',
  'video': '.mp4,.mov',
  'doc': '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf',
};

export const getAzurePhoto = (instance, _account, success, error) => {
  const _request = { scopes: ["User.Read"], account: _account };

  instance.acquireTokenSilent(_request)
    .then(tokenResponse => {
      doFetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
        method: "GET",
        data: null,
        headers: {
          "Content-Type": "application/json",
          'Authorization': "Bearer " + tokenResponse.accessToken,
        },
        responseType: 'arraybuffer'
      })
        .then((resp) => {
          const contentType = resp.headers["content-type"];
          const base64Body = Buffer.from(resp.data, 'binary').toString('base64');
          const base64DataUri = "data:" + contentType + ";base64," + base64Body;
          if (typeof success == 'function') {
            success(base64DataUri)
          }
        }).catch(error);
    }).catch(async (err) => {
      console.log('error getAzurePhoto', err)
      if (typeof error == 'function') {
        error(err)
      }
      if (error instanceof InteractionRequiredAuthError) {
        return instance.acquireTokenPopup(_request);
      }
    })
}

export const showValidationMessage = (validationMessage) => {
  Swal.fire({
    html: validationMessage && validationMessage.length > 0 ? getErrorMessageDisplay(validationMessage) : '',
    title: '',
    icon: 'warning'
  });
}